import { creator } from "../creator";
const typeData = creator.lazy(() => creator
    .union(creator.boolean(), creator.string(), creator.number(), creator.null(), creator.undefined(), typeDataObject, typeDataArray)
    .rename("isly.Json.Data"), "isly.Json.Data");
const typeDataObject = creator.record(creator.string(), typeData).rename("isly.Json.Data.Object");
const typeDataArray = creator.array(typeData).rename("isly.Json.Data.Array");
export var Data;
(function (Data) {
    var _a;
    _a = typeData.bind(), Data.type = _a.type, Data.is = _a.is, Data.flawed = _a.flawed;
    let Object;
    (function (Object) {
        var _a;
        _a = typeDataObject.bind(), Object.type = _a.type, Object.is = _a.is, Object.flawed = _a.flawed;
    })(Object = Data.Object || (Data.Object = {}));
    let Array;
    (function (Array) {
        var _a;
        _a = typeDataArray.bind(), Array.type = _a.type, Array.is = _a.is, Array.flawed = _a.flawed;
    })(Array = Data.Array || (Data.Array = {}));
})(Data || (Data = {}));
//# sourceMappingURL=Data.js.map